import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import HistoryIcon from "@material-ui/icons/History";
import PlusOneIcon from "@material-ui/icons/PlusOne";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitIcon from "@material-ui/icons/ExitToApp";
import { useAuth0 } from "../../react-auth0-spa";
import { Link as RouterLink } from "react-router-dom";
import Link from "@material-ui/core/Link";
import { RedeemCoupon } from "../";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import Badge from "@material-ui/core/Badge";
import Hidden from "@material-ui/core/Hidden";
import AnnounceKit from "announcekit-react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  menuLink: {
    color: "#ffffff",
  },
  menuDivider: {
    "background-color": "rgba(0, 0, 0, 0.2)",
    height: "40px",
    margin: "0px 10px",
    width: "2px",
  },
}));

function Header() {
  const classes = useStyles();
  const { isAuthenticated, logout } = useAuth0();
  // const { isProd, toggleEnv } = useAppContext();

  const [state, setState] = React.useState({
    open: false,
  });

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const Menu = () => (
    <AppBar position="static" style={{ backgroundColor: "#003087" }}>
      <Toolbar>
        <IconButton
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer("open", true)}
        >
          <MenuIcon />
        </IconButton>

        {/* <Link component={Link1} to="/" className={classes.menuLink}> */}
        <Typography variant="h6" className={classes.title}>
          Spanish with Julieth
        </Typography>
        {/* </Link> */}

        <Hidden smDown>
          <RedeemCoupon />
          <Divider orientation="vertical" className={classes.menuDivider} />
          <Link component={Link1} to="/" className={classes.menuLink}>
            <Button variant="outlined" color="inherit">
              Upcoming Lessons
            </Button>
          </Link>
          <Divider orientation="vertical" className={classes.menuDivider} />
          <Link
            component={Link1}
            to="/book-lesson"
            className={classes.menuLink}
          >
            <Button variant="outlined" color="inherit">
              Book a lesson
            </Button>
          </Link>
        </Hidden>

        <Divider orientation="vertical" className={classes.menuDivider} />
        <AnnounceKit widget="https://announcekit.app/widgets/v2/2vC1XO">
          <Hidden smDown>
            <Button variant="outlined" color="inherit">
              What's new
            </Button>
          </Hidden>
        </AnnounceKit>
      </Toolbar>
    </AppBar>
  );

  const Link1 = React.forwardRef((props, ref) => (
    <RouterLink innerRef={ref} {...props} />
  ));

  const SideList = () => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer("open", false)}
      onKeyDown={toggleDrawer("open", false)}
    >
      <List>
        <Link component={Link1} to="/">
          <ListItem button key="apps">
            <ListItemIcon>
              <CalendarIcon />
            </ListItemIcon>
            <ListItemText primary="Upcoming lessons" />
          </ListItem>
        </Link>

        <Link component={Link1} to="/history">
          <ListItem button key="apps">
            <ListItemIcon>
              <HistoryIcon />
            </ListItemIcon>
            <ListItemText primary="History" />
          </ListItem>
        </Link>

        <Link component={Link1} to="/book-lesson">
          <ListItem button key="book-lesson">
            <ListItemIcon>
              <PlusOneIcon />
            </ListItemIcon>
            <ListItemText primary="Book a lesson" />
          </ListItem>
        </Link>

        <Link component={Link1} to="/flashcards">
          <ListItem button key="flashcards">
            <ListItemIcon>
              <ViewCarouselIcon />
            </ListItemIcon>
            <Badge color="primary" variant="dot">
              <ListItemText primary="Flashcards" />
            </Badge>
          </ListItem>
        </Link>

        <Link component={Link1} to="/profile">
          <ListItem button key="profile">
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Profile" />
          </ListItem>
        </Link>
      </List>

      <Divider />

      <List>
        <ListItem button key="logout" onClick={() => logout()}>
          <ListItemIcon>
            <ExitIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </div>
  );

  if (!isAuthenticated) {
    return <div></div>;
  }

  return (
    <div>
      <Menu />
      <Drawer open={state.open} onClose={toggleDrawer("open", false)}>
        <SideList />
      </Drawer>
    </div>
  );
}

export default Header;
